import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "sFloridaCardWidget";
  const widgetOpts = sFloridaCardWidgetOpts;
  const $widgetElement = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: utils.checkWindowsSize(800) ? ["all"] : [""],
    maxItemsVisible: 9,
    itemsPerPanel: 1,
    hasImages: true,
    imageIsBackground: true,
    lazyLoadImages: true,
    showDescription: true,
    textOverImage: true,
    buyNowButton: false,
    moreButton: {
      visible: true,
      text: "",
    },

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".tier-3-container").remove();
      } else {
        createCustomCards(data.items);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widgetElement
      .find(".image-container")
      .append(`<div class="overlay"></div>`);
    $widgetElement
      .find(".buttonwrap .moreButton")
      .attr("aria-label", "Read More");

    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Description, URL } = widgetData[x];
      const $cardElement = $(this);

      if (Description.length == 0) {
        $cardElement.find(".card-widget-description").addClass("noDescr");
      }
      if (URL == null) {
        $cardElement.find(".buttonwrap").addClass("noUrl");
        $cardElement.addClass("voidLink");
        $cardElement.removeAttr("href");
      }
      if (URL == null && Description.length == 0) {
        $cardElement.addClass("emptyCard");
      }
      if (URL && !utils.isLocalUrl(URL)) {
        $cardElement.find(".buttonwrap .button").attr("target", "_blank");
      }
    });
  }
}
